// extracted by mini-css-extract-plugin
export default {"facts":"Facts_facts__wd-Ml"};